// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memberId: __t.string().primaryKey().name("member_id"),
  restaurantId: __t.u64().name("restaurant_id"),
  role: __t.string(),
  name: __t.string(),
  upgradeLevel: __t.u32().name("upgrade_level"),
  trainingCompletesAtMicros: __t.i64().name("training_completes_at_micros"),
  isDeactivated: __t.bool().name("is_deactivated"),
});
